module.exports = __webpack_public_path__ + "img/linkedin-logo.694fc2c9.svg";